export default __webpack_public_path__ + "static/media/daalogo.641d4ad4.png";